import React from 'react';
import { useReferenceData } from './referenceData';
import { shortId } from '../../utils/format';

/** An animal's readable ID (e.g. "COW-000004 — Gauri") from the shared,
 * cached animals reference list - falls back to a short id while loading. */
export function AnimalTag({ id }: { id?: string | null }) {
  const { data } = useReferenceData(['animals']);
  if (!id) return <>—</>;
  const label = data.animals.find((a) => a.value === id)?.label;
  return <>{label ?? shortId(id)}</>;
}
